import { render, staticRenderFns } from "./SurvivalPlot.vue?vue&type=template&id=d3cb960e&scoped=true"
import script from "./SurvivalPlot.vue?vue&type=script&lang=js"
export * from "./SurvivalPlot.vue?vue&type=script&lang=js"
import style0 from "./SurvivalPlot.vue?vue&type=style&index=0&id=d3cb960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cb960e",
  null
  
)

export default component.exports